module.exports = __webpack_public_path__ + "Flag-887.e867ba4b3304d58512c3281004e46ba9.svg";